import { Injectable } from '@angular/core';
// LIBS
import { BehaviorSubject, Observable } from 'rxjs';
// SERVICES
import { LocalStorageService } from '@services/storage/local-storage.service';
import { SYSTEMS } from '@constants/System';
import { SYSTEM_THEMES } from '@constants/Themes';
import { STORAGE_KEYS } from '@constants/StorageKeys';
import { getSystem } from '@utils/system';
import { System } from '@models/System';

@Injectable({
  providedIn: 'root'
})
export class ThemeService {

  constructor(private storageService: LocalStorageService) {
    const {theme} = this.getSystem() || {};
    if (theme) {
      this.changeTheme(theme);
    }
  }

  setUp(systemId: number) {
    const system = getSystem(systemId);
    this.changeTheme(system.theme);
    this.storageService.storeObject(STORAGE_KEYS.SYSTEM, system);
  }

  changeTheme(system: string) {
    const themeCurrent = this.findThemeCurrent();
    this.getElementRef().classList.remove(themeCurrent);
    this.getElementRef().classList.add(system);
  }

  findThemeCurrent() {
    if (this.getElementRef().classList.contains(SYSTEM_THEMES.ra)) {
      return SYSTEM_THEMES.ra;
    } else if (this.getElementRef().classList.contains(SYSTEM_THEMES.valladolid)) {
      return SYSTEM_THEMES.valladolid;
    } else if (this.getElementRef().classList.contains(SYSTEM_THEMES.hlmra)) {
      return SYSTEM_THEMES.hlmra;
    } else {
      return SYSTEM_THEMES.valladolid;
    }
  }

  getElementRef() { return document.documentElement;}

  getSystem(): System {
    return this.storageService.getObject(STORAGE_KEYS.SYSTEM);
  }
}
